'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationInputField = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _LocationInputContainer = require('components/LocationInput/LocationInputContainer');

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationInputField = exports.LocationInputField = function (_Component) {
  (0, _inherits3.default)(LocationInputField, _Component);

  function LocationInputField(props) {
    (0, _classCallCheck3.default)(this, LocationInputField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LocationInputField.__proto__ || (0, _getPrototypeOf2.default)(LocationInputField)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleLoad = _this.handleLoad.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(LocationInputField, [{
    key: 'handleChange',
    value: function handleChange(location) {
      var input = this.props.input;

      input.onChange(location);

      // "Touch" the field to trigger validation.
      input.onFocus();
      input.onBlur();
    }
  }, {
    key: 'handleLoad',
    value: function handleLoad(location) {
      var input = this.props.input;

      input.onChange(location);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          input = _props.input,
          inputAttributes = _props.inputAttributes,
          label = _props.label,
          meta = _props.meta,
          suppressErrorMessage = _props.suppressErrorMessage,
          wrapperAttributes = _props.wrapperAttributes,
          wrapperTag = _props.wrapperTag;


      var hasError = meta.error && meta.touched;

      var inputElement = _react2.default.createElement(_LocationInputContainer.LocationInputContainer, {
        initialValue: (0, _deep.deepExtract)('location.name', input.value),
        inputAttributes: (0, _extends3.default)({}, inputAttributes, {
          className: (0, _classnames2.default)(inputAttributes.className, {
            'form__input--error': hasError
          })
        }),
        label: label,
        onChange: this.handleChange,
        onLoad: this.handleLoad
      });

      var errorElement = void 0;
      if (hasError) {
        errorElement = typeof meta.error === 'string' ? meta.error : _react2.default.createElement(_reactIntl.FormattedMessage, meta.error);
      }

      return _react2.default.createElement(wrapperTag || 'div', wrapperAttributes || {}, inputElement, hasError && !suppressErrorMessage ? _react2.default.createElement(
        'div',
        { className: 'error__text text--sm mt-' },
        errorElement
      ) : null);
    }
  }]);
  return LocationInputField;
}(_react.Component);

LocationInputField.propTypes = {
  input: _propTypes2.default.shape({
    onBlur: _propTypes2.default.func.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    onFocus: _propTypes2.default.func.isRequired,
    value: _propTypes2.default.object
  }),
  inputAttributes: _propTypes2.default.object,
  meta: _propTypes2.default.object,
  label: _propTypes2.default.element,
  suppressErrorMessage: _propTypes2.default.bool,
  wrapperAttributes: _propTypes2.default.object,
  wrapperTag: _propTypes2.default.string
};